import React, { useEffect, useRef, useState } from 'react';

import { IContentUGCPermissions } from  '@/interfaces/contentUGCPermissions';
import { Tag, TagSuggestion } from 'react-tag-autocomplete';
import useDebounce from  '@/components/hooks/useDebounce';
import { getAudienceGroupsForEdit } from '@/api/contentAudience';



const useContentUGCPermissions = ({groupsAllowedToPost}: IContentUGCPermissions) => {
    
    const [contentId, setContentId] = useState<string>((document.querySelector('#Id') as HTMLInputElement)?.value)
    const contentIdRef = useRef<number>(Number((document.querySelector('#Id') as HTMLInputElement)?.value))
    const [selected, setSelected] = useState<Tag[]>([]);

    const [enableRestrictedPosts, setEnableRestrictedPosts] = useState<boolean>(groupsAllowedToPost.length > 0)
    const [checkboxToggle, setCheckboxToggle] = useState<boolean>(false)
    const [showModal, setShowModal] = useState<boolean>(false);

    const [input, setInput] = useState<string>('');
    
    const [suggestions, setSuggestions] = useState<TagSuggestion[]>([])
    const [moreAvailable, setMoreAvailable] = useState<boolean>(false);
    const [currentSkip, setCurrentSkip] = useState<number>(0); 
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const debouncedTerm:string = useDebounce(input, 500);
    const debouncedTermRef = useRef<string>('')

    const getNextPendingRef = useRef<boolean>(false)
    
    useEffect(() => {
        /* hidden read only id field exists on page, because its read only we cannot bind an on change event like you would expect,
            so we have to use a mutation observer this will update when a content id is set on save or save and publish
        */
        if(document.querySelector('#Id')) {
            if(Number(!contentId)) {
                setContentId((document.querySelector('#Id') as HTMLInputElement).value)
            }
            listIdObserver.observe(document?.querySelector?.('#Id') as Node, { attributes: true, childList: true })
        }

        ;(window as any).functions = {...window.functions, refreshUGCGroups: () => getSuggestions(debouncedTerm)};

        return () => {
            delete (window as any).functions.refreshUGCGroups
        }
      
    }, []);

    useEffect(() => {
        contentIdRef.current = Number(contentId);
    }, [contentId])

    useEffect(() => {
        debouncedTermRef.current = debouncedTerm;
    },[debouncedTerm]);

    useEffect(() => {
        if(Number(contentId) && enableRestrictedPosts) {
            getSuggestions(debouncedTerm)

        }
    },[contentId, debouncedTerm, enableRestrictedPosts])


    useEffect(() => {
        setTimeout(() => setSelected(groupsAllowedToPost), 100)
    }, [groupsAllowedToPost])

    useEffect(() => {
        if(selected.length) {
            const ids = selected.map(sel => String(sel.value));
            setControlTextBoxValue(ids)
        }
        else {
            setControlTextBoxValue([]); 
        }
    },[selected])

    useEffect(() => {
        if(checkboxToggle) {
            if(enableRestrictedPosts) {
                setShowModal(true)
            }
            else{
                setEnableRestrictedPosts(true)
            }
        }
        setCheckboxToggle(false);
    },[checkboxToggle])

    function setCheckboxAndClearInputs(){
        setEnableRestrictedPosts(false)
        setShowModal(false)
        setSelected([]);
    }

    function setControlTextBoxValue(ids: string[]){
        (document.querySelector('#AllowedChosenUserPublishingUserGroupsToModify') as HTMLInputElement).value = JSON.stringify(ids);
    }


    const listIdObserver = new MutationObserver((mutation: any[]) => setContentId(() => {
        return mutation[0].target.value
      }));

    function getSuggestions(name: string, paginate: boolean = false) {
        setIsLoading(true);

        getAudienceGroupsForEdit(
            contentIdRef.current,
            {
                SearchTerm: name,
                sortBy: 'groupsName',
                sort: 'asc',
                top:10,
                skip: paginate ? currentSkip : 0,
                filter:{ filterOptions: [], filterGroups:[] }
            }
        ).then(({records, skip, moreAvailable}) => {
            setSuggestions(paginate
                ? [...suggestions, ...records.map(group => ({ label: group.name, value: group.id }))]
                : records.map(group => ({ label: group.name, value: group.id }))
            )
            setCurrentSkip(skip + 10);
            setMoreAvailable(moreAvailable);
        })
        .finally(() => {
            setIsLoading(false)
            getNextPendingRef.current = false
        }); 
      }
    
      function getNextPage(){
        if(!getNextPendingRef.current) {
            getNextPendingRef.current = true
            getSuggestions(debouncedTerm, true)
        }
        
      }

    return {
        contentId,
        selected,
        setSelected,
        enableRestrictedPosts,
        setCheckboxToggle,
        isLoading,
        suggestions,
        setSuggestions,
        input,
        setInput,
        showModal,
        setShowModal,
        setCheckboxAndClearInputs,
        getSuggestions,
        getNextPage,
        moreAvailable,
    }
}

export default useContentUGCPermissions